import type { ReportMapRequest, ReportMapResponse } from "@gettactic/api";
import { REPORT_MAP_QUERY_KEY } from "@gettactic/hooks";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export const useReportMapKey = REPORT_MAP_QUERY_KEY;

/** Per-resource values for one floor and period, for the heatmap overlay. */
export const useReportMap = (request: ReportMapRequest | null) =>
  useQuery<ReportMapResponse>({
    queryKey: [useReportMapKey, request],
    queryFn: async () => {
      if (!request) {
        throw new Error("map request is required");
      }
      const { result } = await api.client.reporting.map(request);
      if (!result) {
        throw new Error("empty report map response");
      }
      return result;
    },
    enabled: !!request,
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000
  });
